import React from "react";
import { makeStyles, Theme, Typography } from "@material-ui/core";
import classNames from "classnames";

const useStyles = makeStyles((theme: Theme) => ({
  midTitle: {
    fontFamily: "Mermaid, sans-serif",
    textAlign: "left",
    fontSize: 60,
    letterSpacing: 0,
    lineHeight: 1.0,
    color: "black",
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      fontSize: 60,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 52,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 44,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 32,
    },
  },
}));

const NormalTitle = (props: any) => {
  const classes = useStyles();
  return (
    <Typography
      variant={props.variant || "h1"}
      className={classNames(classes.midTitle)}
      style={props.style ? { ...props.style } : {}}
    >
      {props.children}
    </Typography>
  );
};

export default NormalTitle;
